import { TableHeader } from "../../commons";
import TimesheetClientWiseMonthlyReportTableData from "./TimesheetClientWiseMonthlyReportTableData";
import { TIMESHEET_CLIENT_WISE_MONTHLY_REPORT_HEADERS } from "../../../constant/timeSheetReportDropDown/timeSheetListConst";
import { ClientWiseMonthlyTimesheetType } from "../../../redux/timeSheet/timeSheetType";

type AppProps = {
  data: ClientWiseMonthlyTimesheetType[] | [];
};

const TimesheetClientWiseMonthlyTable = ({ data }: AppProps) => {
  return (
    <div className="jobsType">
      <table className="table thead-light table-bordered">
        <thead className="text-start sticky-table-header-without-zindex">
          <TableHeader
            tableHeader={TIMESHEET_CLIENT_WISE_MONTHLY_REPORT_HEADERS}
          />
        </thead>
        <tbody>
          <TimesheetClientWiseMonthlyReportTableData
            data={data}
            tableHeader={TIMESHEET_CLIENT_WISE_MONTHLY_REPORT_HEADERS}
          />
        </tbody>
      </table>
    </div>
  );
};

export default TimesheetClientWiseMonthlyTable;
